module.exports = __webpack_public_path__ + "img/product-crunch.45e4ed4f.png";